import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private isDarkTheme = new BehaviorSubject<boolean>(false);
  private THEME_KEY = 'dark-theme-enabled';

  constructor(private storageService: StorageService) {
    this.setDarkTheme(false);
  }

  /**
   * Get the current theme state as an Observable
   */
  public isDarkTheme$(): Observable<boolean> {
    return this.isDarkTheme.asObservable();
  }

  /**
   * Get the current theme state as a boolean
   */
  public isDarkThemeEnabled(): boolean {
    return this.isDarkTheme.value;
  }

  /**
   * Set the theme to dark or light
   * @param isDark Whether to enable dark theme
   */
  public setDarkTheme(isDark: boolean): void {
    this.isDarkTheme.next(false);
    this.storageService.setItem(this.THEME_KEY, 'false');
    document.body.classList.remove('dark-theme');
  }

  /**
   * Toggle between dark and light theme
   */
  public toggleTheme(): void {
    this.setDarkTheme(false);
  }
}
